module.exports = __webpack_public_path__ + "img/agi.76ae3140.svg";